module.exports = __webpack_public_path__ + "static/media/menu-shop.111bcc3d.svg";